export default {
  errors: {
    missing_operator: 'The mathematical expression has no operator',
    missing_operands: 'The mathematical expression requires at least {operandMin} operand(s)'
  }
}
